import { render, staticRenderFns } from "./InactiveLifeTable.vue?vue&type=template&id=d858e28c&"
import script from "./InactiveLifeTable.vue?vue&type=script&lang=js&"
export * from "./InactiveLifeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports